import { PrimaryButton } from 'component-library';
import { useEffect, useRef } from 'react';
import { Oem } from '../../../models/ApiModels';
import Modal from '../../../utils/Modal';
import { launchCombinedConfetti } from '../../Dashboard/dashboardConfetti';

interface Props {
  showOrderConfirmation: boolean;
  setShowOrderConfirmation: () => void;
  currentOem: Oem;
}

const allTargetConfettiKeys = ['systems', 'boats', 'upgrades', 'ultimate'] as const;

export default function OrderConfirmation(props: Props) {
  const hasLaunchedConfettiForCurrentOpen = useRef(false);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | undefined;

    if (props.showOrderConfirmation && !hasLaunchedConfettiForCurrentOpen.current) {
      hasLaunchedConfettiForCurrentOpen.current = true;
      // Delay slightly so modal/overlay is mounted before confetti starts.
      timer = setTimeout(() => {
        void launchCombinedConfetti([...allTargetConfettiKeys], { zIndex: 60 });
      }, 120);
    }

    if (!props.showOrderConfirmation) {
      hasLaunchedConfettiForCurrentOpen.current = false;
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [props.showOrderConfirmation]);

  return (
    <>
      {props.showOrderConfirmation && (
        <Modal>
          <span className='prose-heading3 text-gray-100'>Thank you for your order!</span>
          <span className='prose-paragraphBig text-gray-100'>
            The system license have been upgraded with its new functions and a confirmation will be sent on email to
            <span className='text-primary-100'>
              {' '}
              {props.currentOem?.settings?.orderConfirmationEmail || 'your registered email'}
            </span>
            .
          </span>
          <span className='prose-paragraphBig text-gray-100'>
            To install the new license, the Lightning control panel needs internet connection.{' '}
          </span>
          <div className='flex w-full justify-end'>
            <PrimaryButton label='OK' onClick={() => props.setShowOrderConfirmation()} />
          </div>
        </Modal>
      )}
    </>
  );
}
